/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowRightBetweenLines: {
  name: 'arrow-right-between-lines';
  data: string;
} = {
  name: 'arrow-right-between-lines',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm13.293 2.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L17.586 13H4a1 1 0 1 1 0-2h13.586l-1.293-1.293a1 1 0 0 1 0-1.414ZM4 17a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2H4Z" fill="currentColor"/></svg>`,
};
